import React from 'react';
import { getIndexProtectorLabel } from "../../shared/common";
import classes from './Methodology.css';
import Config from 'Config';
import { connect } from "react-redux";

const methodology = (props) => {
    let imageUrl = Config.princeStyles + "/wadePortrait.png";

    const indexProtector = props.indexProtector ? props.indexProtector : 5;
    const isIAAndIAA = indexProtector.indexOf("INDEX ACHIEVER") !== -1 ? true : false;

    let data = {};
    if (indexProtector.indexOf("INDEX ACHIEVER") !== -1) {
        const rilaData = props.productReducer.rilaData.find((element) => {
            return element.key === indexProtector;
        });
        if (props.accountValue > 250000) {
            data.sp500Minus10Percentage = rilaData.sp500Minus10PercentageOver250K;
            data.sp500OneYear50Percentage = rilaData.sp500OneYear50PercentageOver250K;
            data.sp500OneYear10Percentage = rilaData.sp500OneYear10PercentageOver250K;
            data.sp500SixYear10Percentage = rilaData.sp500SixYear10PercentageOver250K;
            data.eafeOneYear50Percenpage = rilaData.eafeOneYear50PercenpageOver250K;
            data.eafeOneYear10Percenpage = rilaData.eafeOneYear10PercenpageOver250K;
            data.realEstateOneYear50Percentage = rilaData.realEstateOneYear50PercentageOver250K;
            data.realEstateOneYear10Percentage = rilaData.realEstateOneYear10PercentageOver250K;
            data.spdrOneYear50Percentage = rilaData.spdrOneYear50PercentageOver250K;
            data.spdrOneYear10Percentage = rilaData.spdrOneYear10PercentageOver250K;
        } else {
            data.sp500Minus10Percentage = rilaData.sp500Minus10Percentage;
            data.sp500OneYear50Percentage = rilaData.sp500OneYear50Percentage;
            data.sp500OneYear10Percentage = rilaData.sp500OneYear10Percentage;
            data.sp500SixYear10Percentage = rilaData.sp500SixYear10Percentage;
            data.eafeOneYear50Percenpage = rilaData.eafeOneYear50Percenpage;
            data.eafeOneYear10Percenpage = rilaData.eafeOneYear10Percenpage;
            data.realEstateOneYear50Percentage = rilaData.realEstateOneYear50Percentage;
            data.realEstateOneYear10Percentage = rilaData.realEstateOneYear10Percentage;
            data.spdrOneYear50Percentage = rilaData.spdrOneYear50Percentage;
            data.spdrOneYear10Percentage = rilaData.spdrOneYear10Percentage;
        }
    } else {
        data = props.productReducer.productsData.find((element) => {
            return element.key === "IP" + indexProtector;
        });
    }

    let itemList;
    let itemCount;
    if (indexProtector === "INDEX ACHIEVER") {
        itemList = (
            <React.Fragment>
                1-Year Term -10% Floor with Cap <br />
                1-Year Term 50% Downside Participation Rate with Upside Participation Rate <br />
                1-Year Term 10% Buffer with Cap <br />
                6-Year Term 10% Buffer with Upside Participation Rate <br />
            </React.Fragment>
        );
        itemCount = "four";
    } else if (indexProtector === "INDEX ACHIEVER ADVISORY") {
        itemList = (
            <React.Fragment>
                1-Year Term -10% Floor with Cap <br />
                1-Year Term 50% Downside Participation Rate with Upside Participation Rate <br />
                1-Year Term 10% Buffer with Cap <br />
                6-Year Term 10% Buffer with Upside Participation Rate <br />
            </React.Fragment>
        );
        itemCount = "four";
    } else if (props.companyName !== "WELLS_FARGO") {
        itemList = (
            <React.Fragment>
                S&P 500® point-to point with cap - {data.sp500.value.toFixed(2)}% Cap Rate <br />
                {props.indexProtector != 5 && <React.Fragment>
                    S&P 500® Risk Control point-to-point with participation rate - {data.riskControl.value.toFixed(2)}% Participation Rate <br />
                    S&P U.S. Retiree Spending® point-to-point with participation rate - {data.retireeSpending.value.toFixed(2)}% Participation Rate <br />
                    iShares U.S. Real Estate® point-to-point with cap - {data.yir.value.toFixed(2)}% Cap <br />
                </React.Fragment>}
                iShares MSCI EAFE point-to-point with cap - {data.efa.value.toFixed(2)}% Cap <br />
                {data.barclay && (<React.Fragment>First Trust Barclays Edge Index 1-year point-to-point with cap - {data.barclay.value.toFixed(2)}% Cap Rate <br /></React.Fragment>)}
            </React.Fragment>
        );
        itemCount = data.barclay ? "six" : "five";
    } else {
        itemList = (
            <React.Fragment>
                S&P 500® point-to point with cap - {data.sp500.value.toFixed(2)}% Cap Rate  <br />
                iShares MSCI EAFE point-to-point with cap - {data.efa.value.toFixed(2)}% Cap  <br />
                First Trust Barclays Edge Index 1-year point-to-point with cap - {data.barclay.value.toFixed(2)}% Cap Rate <br />
            </React.Fragment>
        );
        itemCount = "three";
    }

    return (
        <div>
            <h2 className={classes.title}>inStream’s Annuity Calculator</h2>
            <p>
                This calculator allows users to investigate the role of {isIAAndIAA ? "registered index-linked" : "fixed indexed"} annuities as an asset class within
                an accumulation portfolio. The calculator includes the {getIndexProtectorLabel(props.indexProtector)}, a {isIAAndIAA ? "registered index-linked" : "indexed"} annuity issued by
                MassMutual Ascend Life Insurance Company, as an available asset class and allows users to compare the
                distribution of potential wealth accumulation with and without a role for a {isIAAndIAA ? "registered index-linked" : "indexed"} annuity. The
                {isIAAndIAA ? " registered index-linked" : " indexed"} annuity allows for different indexed strategies which all provide {isIAAndIAA ? "partial" : ""} downside protection
                {isIAAndIAA ? "" : " with a 0% floor on returns"}, while allowing for some participation in the market upside through indices linked
                to the stock market. It may serve as a suitable replacement for bonds or other asset classes with a low
                correlation to the stock market within an accumulation portfolio. The indexed strategies include:
            </p>
            <p>
                {itemList}
            </p>
            <p>
                The {isIAAndIAA ? "registered index-linked" : "indexed"} annuity also offers a declared rate strategy with a fixed interest rate.  The declared rate strategy is not available for
                hypothetical allocations when using this calculator.
            </p>
            <p>
                The calculator works by simulating accumulation values for an asset allocation strategy using Monte
                Carlo simulation. Each potential asset class is assigned an average return and volatility assumption
                based on historical data, along with correlations to other asset classes, and randomized returns are
                then simulated for the overall portfolio by created randomized draws with these portfolio
                characteristics.
                {isIAAndIAA ?
                    " The asset class characteristics are based on annualized values for the monthly returns using seventeen years of data from January 2005 through December 2022."
                    :
                    " The asset class characteristics are based on annualized values for the monthly returns using ten years of data from January 2016 through December 2025."}
            </p>
            <p>
                Users can compare a benchmark portfolio to an alternative portfolio that includes an allocation to {isIAAndIAA ? "a registered index-linked" : "an indexed"} annuity. In the comparison scenario, certain asset classes from the original portfolio are replaced with the {isIAAndIAA ? "registered index-linked" : "indexed"} annuity based on which assets have the {isIAAndIAA ? "highest" : "lowest"} correlations to the annuity. In most cases, this results in {isIAAndIAA ? "equity" : "fixed income"} allocations being replaced first.
            </p>
            <p>
                When {isIAAndIAA ? "a registered index-linked" : "an indexed"} annuity is included, returns are calculated by applying the {isIAAndIAA ? "applicable caps" : "applicable cap"} and {isIAAndIAA ? "upside " : ""}participation rates {isIAAndIAA ? "and the applicable floors, downside participation rates and buffers " : ""}to the simulated index performance before being reflected in the portfolio results.
            </p>
            <p>
                Users can adjust market conditions to evaluate how changes in expected return assumptions impact portfolio outcomes. A market condition slider allows users to increase or decrease expected returns across simulated asset classes, while keeping volatility and correlation assumptions constant.
            </p>
            <p>
                For equities, this involves adjusting the expected return to match a different percentile from the historical of returns. For instance, a big bear market reflects having the average return centered on the 10th percentile of historical returns, while a big bull market reflects having the average return centered on the 90th percentile of historical returns. For bonds, scenarios are created through reflecting upon the impact of potential interest rate changes from the current levels, with increasing interest rates reflecting a bear market for bonds through their capital losses.
            </p>
            <p>
                These adjustments allow users to assess how incorporating {isIAAndIAA ? "a registered index-linked" : "an indexed"} annuity may influence portfolio outcomes across different market environments, particularly in reducing downside exposure while participating in a portion of potential upside returns.
            </p>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName,
        accountValue: state.planInfo.accountInfo.value
    }
};

export default connect(mapStateToProps)(methodology);


// WEBPACK FOOTER //
// ./src/components/Methodology/Methodology.js